import type { ApiClient } from '../client';
import { SCHOOL_API_PATHS, TENANT_PATHS } from '../../../config/api-paths';
import type { ApiResponse, CreateAcademicYearRequest, CreateAcademicYearResponse, ListAcademicYearsResponse, SchoolBranchesJson, SchoolProfileJson, SeedReportCardBoardDefaultsResponse, TenantSettingsResponse, UpdateSchoolProfileRequest } from '../types';

export function bindSchool(client: ApiClient) {
  return {
async getSchoolProfile(): Promise<ApiResponse<SchoolProfileJson>> {
    return client.request<SchoolProfileJson>(SCHOOL_API_PATHS.profile);
  },

async updateSchoolProfile(body: UpdateSchoolProfileRequest): Promise<ApiResponse<SchoolProfileJson>> {
    return client.request<SchoolProfileJson>(SCHOOL_API_PATHS.profile, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

async getTenantSettings(options?: {
    suppressSessionExpiry?: boolean;
  }): Promise<ApiResponse<TenantSettingsResponse>> {
    return client.request<TenantSettingsResponse>(TENANT_PATHS.settings, {
      suppressSessionExpiry: options?.suppressSessionExpiry,
    });
  },

async seedReportCardBoardDefaults(): Promise<ApiResponse<SeedReportCardBoardDefaultsResponse>> {
    return client.request<SeedReportCardBoardDefaultsResponse>('/report-cards/seed-board-defaults', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },

async listSchoolBranches(): Promise<ApiResponse<SchoolBranchesJson>> {
    return client.request<SchoolBranchesJson>(SCHOOL_API_PATHS.branches);
  },

async listAcademicYears(): Promise<ApiResponse<ListAcademicYearsResponse>> {
    return client.request<ListAcademicYearsResponse>(SCHOOL_API_PATHS.academicYears);
  },

async createAcademicYear(body: CreateAcademicYearRequest): Promise<ApiResponse<CreateAcademicYearResponse>> {
    return client.request<CreateAcademicYearResponse>(SCHOOL_API_PATHS.academicYears, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
  };
}
